// extracted by mini-css-extract-plugin
module.exports = {"base":"H2_base__wksW3","icon":"H2_icon__f3PR7","marginReset":"H2_marginReset__NG93b"};